export const navbarItems = [
  { id: 891232671, title: "About school", path: "#about" },
  { id: 891232672, title: "Subjects", path: "#subjects" },
  { id: 891232523, title: "Facilities", path: "#facilities" },
  { id: 891232673, title: "Teachers", path: "#teachers" },
  { id: 891232674, title: "Students", path: "#students" },
  { id: 891232674, title: "Awards", path: "#awards" },
  { id: 891232674, title: "Contact", path: "#contact" },
];
